{
  "平台公告": "Platform announcements",
  "新增公告": "New announcement",
  "编辑公告": "Edit announcement",
  "公告标题": "Title",
  "英文标题": "English title",
  "公告内容": "Content",
  "英文内容": "English content",
  "留空时英文环境显示中文标题": "Leave blank to show the Chinese title in English",
  "留空时英文环境显示中文内容": "Leave blank to show the Chinese content in English",
  "停用后商家工作台不再显示此公告。": "A disabled announcement no longer appears in the merchant workspace.",
  "公告已删除": "Announcement deleted",
  "删除后无法恢复，商家工作台将不再显示。": "Deletion cannot be undone. The merchant workspace stops showing it.",
  "删除“{{name}}”？": "Delete \"{{name}}\"?",
  "{{name}}启用状态": "{{name}} availability",
  "还没有公告": "No announcements yet",
  "已填写": "Provided",
  "未填写": "Not provided",
  "正文格式": "Content format",
  "纯文本": "Plain text",
  "富文本": "Rich text",
  "写公告正文": "Write the announcement",
  "写英文公告正文": "Write the English announcement"
}
